import { render, staticRenderFns } from "./PhotoUploadBeforeAfterTable.vue?vue&type=template&id=cbc2b260&scoped=true"
import script from "./PhotoUploadBeforeAfterTable.vue?vue&type=script&lang=js"
export * from "./PhotoUploadBeforeAfterTable.vue?vue&type=script&lang=js"
import style0 from "./PhotoUploadBeforeAfterTable.vue?vue&type=style&index=0&id=cbc2b260&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc2b260",
  null
  
)

export default component.exports